import { Container, Grid, Header } from "semantic-ui-react";

import * as React from "react";

import { DepartmentFilter, AllDepartmentsOption } from "./DepartmentFilter";
import { TeamSraSummary } from "./TeamSraSummary";

export const SraSurveyResults: React.FunctionComponent = () => {
    const [selectedDepartmentId, setSelectedDepartmentId] = React.useState<string>(AllDepartmentsOption);

    return (
        <Container className="sra-summary-container">
            <>
                <Grid columns="equal" stackable>
                    <Grid.Column>
                        <Header as="h1" className="accent-header">Summary of Team Results</Header>
                    </Grid.Column>
                    <Grid.Column width="4">
                        <DepartmentFilter selectedDepartmentId={selectedDepartmentId} onDepartmentSelected={setSelectedDepartmentId} />
                    </Grid.Column>
                </Grid>
            </>
            <TeamSraSummary departmentId={selectedDepartmentId} />
        </Container>
    );
};
